import { FC, useRef, useState } from 'react';
import { useClickOutside } from '../../../utils/click-outside';
import { Collapser, Toggle, VText } from '@vake/ui-kit';
import { addReportKindSymbol } from '../../../utils/report-kind-icons';

export const ReportFilterComponents: FC<{
    filterReportType: ReportType[];
    setFilterReportType: (item: ReportType[]) => void;
}> = ({ filterReportType, setFilterReportType }) => {
    const [openTypes, setOpenTypes] = useState(false);
    const [openSort, setOpenSort] = useState(false);
    const wrapperRef = useRef<HTMLDivElement>(null);

    const handleToggle = (toggledFilter: ReportType) => {
        if (filterReportType.includes(toggledFilter)) {
            setFilterReportType(filterReportType.filter((item) => item !== toggledFilter));
        } else setFilterReportType([...filterReportType, toggledFilter]);
    };

    useClickOutside(wrapperRef, setOpenTypes);

    return (
        <>
            <div className="flex gap-3 content-center">
                <VText className="content-center" significance="tertiary">
                    Filter:
                </VText>

                <div className="relative" ref={wrapperRef}>
                    <Collapser open={openTypes} description={<VText>All types</VText>} setOpen={setOpenTypes}>
                        <div
                            ref={wrapperRef}
                            className="absolute top-6 bg-background-secondary p-4 rounded-md  z-10 border-label-tertiary border-2"
                        >
                            <div className="flex justify-between gap-4 pb-2">
                                <div className="flex gap-2">
                                    {addReportKindSymbol('pathfinder')}
                                    <VText>Pathfinder</VText>
                                </div>
                                <Toggle
                                    size="small"
                                    isOn={filterReportType.includes('Pathfinder')}
                                    onChange={() => handleToggle('Pathfinder')}
                                    onBackgroundColor="success-background"
                                />
                            </div>
                            <div className="flex justify-between gap-4 pointer-events-auto">
                                <div className="flex gap-2">
                                    {addReportKindSymbol('overwatch')}
                                    <VText>Overwatch</VText>
                                </div>
                                <Toggle
                                    size="small"
                                    isOn={filterReportType.includes('Overwatch')}
                                    onChange={() => handleToggle('Overwatch')}
                                    onBackgroundColor="success-background"
                                />
                            </div>
                        </div>
                    </Collapser>
                </div>
            </div>
            <div ref={wrapperRef} className="flex gap-3 content-center">
                <VText className="content-center" significance="tertiary">
                    Sort:
                </VText>
                <Collapser open={openSort} description={<VText>Last Modified</VText>} setOpen={setOpenSort}>
                    <VText>Underpoint 1</VText>
                    <VText>Underpoint 2</VText>
                </Collapser>
            </div>
        </>
    );
};
